import api from "@/api/api"
import { query, mutation } from "../../api/queries"
import dayjs from "dayjs"

export default {
	async setProperty({ commit }, { path, value }) {
		commit("setProperty", { path, value })
	},

	async fetchProduct({ commit, rootState }, { productId, locale }) {
		// Reset previous product
		commit("setProduct", null)

		const res = await api({
			query: query.product,
			locale,
			variables: {
				where: {
					productId
				}
			}
		})

		// Check error
		if (!res?.data?.products?.list) return Promise.resolve({ isSuccess: false, res })

		// Append computed fields
		const dateTimeFormat = rootState.settings.dateTimeFormat
		const product = res?.data?.products?.list?.[0] ?? {}
		product.formattedCreatedAt = product.createdAt ? dayjs(product.createdAt).format(dateTimeFormat) : ""
		product.formattedLastModifiedAt = product.lastModifiedAt ? dayjs(product.lastModifiedAt).format(dateTimeFormat) : ""

		commit("setProduct", product)
		return Promise.resolve({ isSuccess: true, res })
	},

	async updateProduct({ dispatch }, payload) {
		const { name, plan, type, version, locale, insurerId } = payload

		const l10n = {
			locale,
			key: `products-${plan || ""}|${version || ""}|${type || ""}-name`,
			value: name
		}

		const res = await api({
			query: mutation.upsertL10n,
			variables: { l10n }
		})

		// Check errors
		if (res?.data?.upsertL10n?.status !== "success")
			return Promise.resolve({ isSuccess: false, res: res, error: res?.data?.upsertL10n?.errors?.[0] })

		// Update product
		const res2 = await api({
			query: mutation.updateProduct,
			variables: { productId: { plan, type, version }, input: { insurerId } }
		})

		// Check errors
		if (!res2?.data?.updateProduct?.productId)
			return Promise.resolve({ isSuccess: false, res: res2, error: res?.errors?.[0]?.message })

		const productId = { plan, type, version }
		dispatch("fetchProduct", { productId, locale })
		return Promise.resolve({ isSuccess: true, res: res })
	}
}
